import { Card } from "primereact/card";
import { useParams } from "react-router-dom";
import React from "react";
import CustomeButton from "~/components/Button";
import "../shareholder-form.scss";
import useShareholderProfileAttachments from "./useShareholderProfileAttachments";
import FileUploadModal from "~/components/Processes/conversations/FileUploadModal";
import ShareholderAttachmentTable from "./ShareholderAttachmentTable";
import Notification from "../../entities/notification/Notification";
import AdminOnly from "~/components/AdminOnly";
import { useShareHolderDetails } from "../ShareHolderDetail";
import AuditSidebar from "~/components/audit-sidebar/AuditSidebar";
import API_ROUTES from "~/api-routes";
import TemporaryNotification from "~/components/toast-notification/AttachmentTemporaryNotification";
import DocumentConfirmationDialog from "~/components/confirmation-dialog/DocumentConfirmationDialog";
import AttachmentSuccess from "~/components/toast-notification/AttachmentSuccess";

const ShareholderProfileAttachments = () => {
  const { id } = useParams();

  const {
    regData: { entityData },
    loading: isRegDataLoading,
  } = useShareHolderDetails();
  const {
    filesData,
    loading,
    rows,
    first,
    onPageChange,
    isDataAvailable,
    setOpenDialog,
    fileSupported,
    openDialog,
    uploadFileHandler,
    shareHolderData,
    isFileUploaded,
    successMessage,
    setSuccessMessage,
    getNameForFile,
    isAuditSidebarVisible,
    setAuditSidebarVisible,
    handleConfirmDelete,
    handleDeleteDocument,
    attachmentConfirmModal,
    setAttachmentConfirmModal,

    isAttachmentLoader,
    handleRestoreAttachment,
    temporaryMessage,
    setTemporaryMessage,
    restoreMessage,
    setRstoreMessage,
  } = useShareholderProfileAttachments(entityData, isRegDataLoading);

  const auditLabels = () => {
    return {
      create: "File Uploaded",
      update: "File Updated",
      delete: "File(s) Deleted",
    };
  };
  return (
    <Card className="gen-card shareholder__attachments">
      <div className="flex justify-content-between">
        <div>
          <p className="shareholder__attachments--heading m-0">Attachments</p>
        </div>
        <AdminOnly>
          <div className="inline-flex gap-2">
            <CustomeButton
              label="View History"
              icon="pi pi-history"
              iconPos="right"
              className="edit-button"
              onClick={() => setAuditSidebarVisible(true)}
            />
            <CustomeButton
              label="Upload File"
              icon="pi pi-upload"
              iconPos="right"
              className="upload-file-button"
              onClick={() => setOpenDialog(true)}
            />
          </div>
        </AdminOnly>
      </div>

      <Notification
        successMessage={successMessage}
        setSuccessMessage={setSuccessMessage}
      />
      <TemporaryNotification
        onUndo={handleRestoreAttachment}
        successMsg={temporaryMessage}
        setMessages={setTemporaryMessage}
      />
      <AttachmentSuccess
        successMsg={restoreMessage}
        setMessages={setRstoreMessage}
      />
      <div className="mt-4">
        <ShareholderAttachmentTable
          files={filesData}
          loading={loading}
          first={first}
          rows={rows}
          onPageChange={onPageChange}
          isDataAvailable={isDataAvailable}
          setOpenDialog={setOpenDialog}
          handleAttachmentDelete={handleDeleteDocument}
          attachmentConfirmModal={attachmentConfirmModal}
          setAttachmentConfirmModal={setAttachmentConfirmModal}
          handleConfirmDelete={handleConfirmDelete}
        />
      </div>
      <FileUploadModal
        entitydata={shareHolderData?.entityData}
        showModal={openDialog}
        fileSupported={fileSupported}
        hideUploadModal={() => setOpenDialog(false)}
        setUploadedFile={uploadFileHandler}
        getService={getNameForFile}
        placeholder={"Choose a file to upload"}
        loading={!isFileUploaded}
        close={false}
        shareholderdata={shareHolderData}
        relatedType={"SHAREHOLDER"}
      />

      {isAuditSidebarVisible && (
        <AuditSidebar
          heading="Attachments"
          endpoint={API_ROUTES.FETCH_ATTACHMENT_AUDIT}
          id={id}
          objectType="SHAREHOLDERS"
          setSidebarToggle={setAuditSidebarVisible}
          sidebarToggle={isAuditSidebarVisible}
          labels={auditLabels}
        />
      )}
      {attachmentConfirmModal && (
        <DocumentConfirmationDialog
          visible={attachmentConfirmModal}
          closeModal={() => setAttachmentConfirmModal(false)}
          handleSave={handleConfirmDelete}
          isLoader={isAttachmentLoader}
        />
      )}
    </Card>
  );
};

export default ShareholderProfileAttachments;
